import { gearProducts } from '@/data/gear';
import type { Product, ProductVariant } from './types';

/**
 * The catalogue listing, from the site's own gear file. Async so every page keeps the shape it
 * had when this came over the network; it never fails for a reason outside this site.
 */
export function fetchProducts(): Promise<Product[]> {
  return Promise.resolve([...gearProducts()]);
}

export function fetchProductByHandle(handle: string): Promise<Product | null> {
  return Promise.resolve(gearProducts().find((product) => product.handle === handle) ?? null);
}

/** The product and variant behind a variant id, or null when the catalogue no longer lists it. */
export function findVariant(variantId: string): { readonly product: Product; readonly variant: ProductVariant } | null {
  for (const product of gearProducts()) {
    const variant = product.variants.find((candidate) => candidate.id === variantId);
    if (variant !== undefined) return { product, variant };
  }
  return null;
}
